export function pickLocalized(base: string, en: string | null | undefined, lang: "es" | "en"): string {
  return lang === "en" && en ? en : base;
}
